"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.product = exports.standardDeviation = exports.variance = exports.median = exports.mean = exports.count = exports.nzmin = exports.min = exports.max = exports.sum = exports.removeNulls = exports.isDefined = exports.AggregateError = void 0;
class AggregateError extends Error {
    constructor(msg) {
        super(msg);
        Object.setPrototypeOf(this, AggregateError.prototype);
    }
}
exports.AggregateError = AggregateError;
function isDefined(a) {
    return a !== null;
}
exports.isDefined = isDefined;
function removeNulls(list) {
    return list.filter(isDefined);
}
exports.removeNulls = removeNulls;
function sum(list) {
    let sumTotal = 0;
    list.forEach((value) => {
        sumTotal += value !== null && value !== void 0 ? value : 0;
    });
    return sumTotal;
}
exports.sum = sum;
function max(list) {
    return Math.max(...removeNulls(list));
}
exports.max = max;
function min(list) {
    return Math.min(...removeNulls(list));
}
exports.min = min;
function nzmin(list) {
    let min = Infinity;
    removeNulls(list).forEach((value) => {
        if (value !== 0 && value < min) {
            min = value;
        }
    });
    return min;
}
exports.nzmin = nzmin;
function count(list) {
    return list.length;
}
exports.count = count;
function mean(list) {
    return sum(list) / list.length;
}
exports.mean = mean;
function median(list) {
    if (list.length === 0) {
        return 0;
    }
    const sorted = removeNulls(list).slice(0);
    sorted.sort((a, b) => {
        return a - b;
    });
    var len = sorted.length;
    if (len % 2 !== 0) {
        return sorted[Math.floor(len / 2)];
    }
    else {
        return (sorted[len / 2 - 1] + sorted[len / 2]) / 2;
    }
}
exports.median = median;
function variance(list) {
    const nonNullList = removeNulls(list);
    let m = mean(nonNullList);
    let sum = 0.0;
    for (let i = 0; i < nonNullList.length; i++) {
        sum = sum + (nonNullList[i] - m) * (nonNullList[i] - m);
    }
    let v = sum / nonNullList.length;
    if (v < 0)
        throw new AggregateError("Variance is never negative");
    return v;
}
exports.variance = variance;
function standardDeviation(list) {
    return Math.sqrt(variance(list));
}
exports.standardDeviation = standardDeviation;
function product(list) {
    return list.reduce((acc, cur) => acc * (cur !== null && cur !== void 0 ? cur : 0), 1);
}
exports.product = product;
//# sourceMappingURL=aggregate.js.map